module.exports = __webpack_public_path__ + "static/img/-6_06.28cf027.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue6/-6_06.jpg
// module id = XBAF
// module chunks = 7